module.exports = __webpack_public_path__ + "static/img/result_none.78f7a4f5.png";